import Service from 'additiv-services';
import i18n from 'i18next';
import { BASIC_DMS_API_URL_V21 } from './const';

const getToken = () => {
    const token = {};

    Object.keys(sessionStorage).forEach((key) => {
        if (key.includes('oidc')) {
            token[key] = sessionStorage.getItem(key);
        }
    });

    return `Bearer ${Object.values(token).id_token}`;
};

class DocumentService extends Service {
    static getDocumentCategoriesList(params) {
        return Service.getRequest(`${BASIC_DMS_API_URL_V21}/categories?documentTypeId=${params?.documentTypeId || 2}&isActive=true&language=${i18n.language}`, {
            isSecure: true,
            headers: [
                { authorization: getToken() },
            ],
        });
    }

    static getDocumentMetaDataList(params) {
        return Service.postRequest(`${BASIC_DMS_API_URL_V21}/metadata/lookup`, {
            'Accept-Language': i18n.language,
            isActive: true,
            metadataAccessPolicy: 'Read',
            documentType: 'General', // [ Client, General ]
            documentCategoryIds: [
                params?.documentCategoryId || 2,
            ],
        }, {
            isSecure: true,
            headers: [
                { authorization: getToken() },
            ],
        });
    }
}
export default DocumentService;
